import { Pipe, PipeTransform } from '@angular/core';
import { PipeBreadcrumb, StorageDataLevel } from '../models/storage-data-type';

@Pipe({
  name: 'storageBreadcrumb',
  pure: false
})
export class StorageBreadcrumbPipe implements PipeTransform {
  arrayOfNames: PipeBreadcrumb[] = [];

  transform(breadCrumbData: StorageDataLevel[], length: number): unknown {
    if(!breadCrumbData || breadCrumbData.length == 0) return breadCrumbData;
    let newBreadcrumbData: StorageDataLevel[] = breadCrumbData;

    if(newBreadcrumbData.length > length){
      newBreadcrumbData.forEach((ele, i) => {
        let idx = this.arrayOfNames.findIndex(obj => obj.itemPath == ele.path)
        if(idx == -1) this.arrayOfNames.push(new PipeBreadcrumb(ele.name, ele.path))

        if(i > 2 && i < newBreadcrumbData.length - 1){
          newBreadcrumbData[i].ui_name = '..';
        }

      });
    }
    if(newBreadcrumbData[newBreadcrumbData.length - 1].ui_name == '..'){
      let idx = this.arrayOfNames.findIndex(obj => obj.itemPath == newBreadcrumbData[newBreadcrumbData.length - 1].path)
      if(idx != -1) newBreadcrumbData[newBreadcrumbData.length - 1].ui_name = this.arrayOfNames[idx].itemName
    }
    
    return newBreadcrumbData;
  }
}